import http from "../../http-common";

const getAllCompanies = async () => {
  return await http
    .get("/ultimate/companies")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getCompanyById = async (id) => {
  return await http
    .get(`/ultimate/companies/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateCompany = async (id, data) => {
  return await http
    .put(`/ultimate/companies/${id}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getCompanyPrecifications = async (id) => {
  return await http
    .get(`/ultimate/companies/${id}/precifications`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};


const getCompanyCommission = async (id) => {
  return await http
    .get(`/ultimate/companies/${id}/commission`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const upsertCompanyCommission = async (id, data) => {
  return await http
    .put(`/ultimate/companies/${id}/commission`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const deleteCompanyCommission = async (id) => {
  return await http
    .delete(`/ultimate/companies/${id}/commission`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createPrecification = async (id, data) => {
  return await http
    .post(`/ultimate/companies/${id}/precifications`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll: getAllCompanies,
  getById: getCompanyById,
  update: updateCompany,
  getPrecifications: getCompanyPrecifications,
  createPrecification: createPrecification,
  getCommission: getCompanyCommission,
  upsertCommission: upsertCompanyCommission,
  deleteCommission: deleteCompanyCommission,
};
